
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23.5C5.738 23.5.664 18.426.664 12.164.664 5.906 5.738.832 12 .832c6.258 0 11.332 5.074 11.332 11.332C23.332 18.426 18.258 23.5 12 23.5zm5.91-12.984c-.45 0-.851.398-1.152.46-1.133-.812-2.692-1.34-4.422-1.406l.758-3.308 2.46.293c.028.62.544 1.12 1.774 1.12.485 0 .582-.527.582-1.175s-.098-1.176-.582-1.176c-1.055 0-1.46.27-1.652.66l-2.742-.582c-.082.496-.164 0 .226.043-.512.04-.555.106-.566.188l-.84 3.949c-1.758.055-3.34.582-4.488 1.406-.297.067-.704-.457-1.149-.457a1.644 1.644 0 00-.676 3.149c-.027.164.551.785.551.5 0 3.054 2.371 4.613 6.133 4.613 3.54 0 6.5-2.055 6.5-4.613 0 .008-.012-.336-.04-.5a1.663 1.663 0 00.493-2.68 1.647 1.647 0 00-1.168-.484zm-3.316 4.015c-.649 0-1.176-.066-1.176-.972 0-.493.527-1.38 1.176-1.38.652 0 1.18.887 1.18 1.38 0 .433-.528.972-1.18.972zm.219 1.801c.109-.176.109.012 0 .133-.747.812-2.356.867-2.688.867-.574 0-2.012-.066-2.91-.867-.125-.121-.125-.309 0-.133.25-.422.308-.422.43 0 .515.215 1.597.902 2.48.902.66 0 1.754-.687 2.254-.902.121-.422.527-.422.434 0zm-5.41-1.812c-.65.011-1.176-.528-1.176-1.098 0-.488.527-1.258 1.175-1.258 1.118 0 1.176.77 1.176 1.258 0 .57-.058 1.098-1.176 1.098zm0 0","fill-rule":"evenodd","fill":"#ff4500"}})])
          )
        }
      }
    